import { EventTypes, getPageSource, Locations, track } from '@mc/track-event'
import {
  PLAN_NAMES,
  PRO_MEMBERSHIP_LOCATION,
  PRO_SECTION_LOCATION,
  type Plan,
} from './constants'

const classPageProps = (slug: string) => ({
  class: slug,
  page_category: 'class',
  page_path: window.location.pathname,
  page_source: getPageSource(),
})

export const trackProHeroViewed = (slug: string) =>
  track('MasterClass Pro Section Viewed', {
    ...classPageProps(slug),
    location: Locations.HERO,
  })

export const trackPlanCardClicked = (plan: Plan, slug: string) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    ...classPageProps(slug),
    action: `Plan card clicked: ${PLAN_NAMES[plan]}`,
    location: PRO_MEMBERSHIP_LOCATION,
  })

export const trackProSectionViewed = () =>
  track('Page Section Viewed', {
    location: PRO_SECTION_LOCATION,
    page_source: getPageSource(),
    position: 5,
  })

export const trackProBannerLearnMoreClicked = (slug: string) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    ...classPageProps(slug),
    action: 'Learn more',
    location: PRO_MEMBERSHIP_LOCATION,
  })
